var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: { "is-modified": _vm.isModified },
      scopedSlots: _vm._u([
        {
          key: "before-label",
          fn: function () {
            return [
              _c("label", { staticClass: "boss-checkbox" }, [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox", "data-test": "input" },
                  domProps: { checked: _vm.isModified },
                  on: {
                    change: function ($event) {
                      return _vm.changeModified($event.target.checked)
                    },
                  },
                }),
                _vm._v("\n      " + _vm._s(_vm.name) + "\n    "),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pega-work-style-slider",
          attrs: { "data-test": "slider" },
          on: {
            click: function ($event) {
              return _vm.changeModified(true)
            },
          },
        },
        [
          _c("vue-slider", {
            staticClass: "margin-left-3 margin-right-3",
            attrs: {
              adsorb: true,
              min: 1,
              max: 5,
              marks: true,
              "hide-label": true,
              disabled: !_vm.isModified,
              tooltip: "none",
              "data-test": "vue-slider",
            },
            on: { change: _vm.changeVolition },
            scopedSlots: _vm._u([
              {
                key: "dot",
                fn: function () {
                  return [
                    _c("div", {
                      class: ["custom-dot", { active: _vm.isModified }],
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "step",
                fn: function (ref) {
                  var active = ref.active
                  return [
                    _c("div", {
                      class: [
                        "custom-step",
                        { active: _vm.isModified && active },
                      ],
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.internalVolition,
              callback: function ($$v) {
                _vm.internalVolition = $$v
              },
              expression: "internalVolition",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              {
                staticClass: "cell small-4",
                attrs: { "data-test": "left-label" },
              },
              [_vm._v("\n        " + _vm._s(_vm.leftLabel) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cell small-4 text-center",
                attrs: { "data-test": "center-label" },
              },
              [_vm._v("\n        どちらともいえない\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cell small-4 boss-align-right",
                attrs: { "data-test": "right-label" },
              },
              [_vm._v("\n        " + _vm._s(_vm.rightLabel) + "\n      ")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }